import { useEffect, useState } from "react";

// Anything at laptop-min-width or wider is treated as a hover-capable viewport.
// Matches the breakpoint used inline in navigation.tsx.
const HOVER_VIEWPORT_MIN_WIDTH = 1025;
const MEDIA_QUERY = `(min-width: ${HOVER_VIEWPORT_MIN_WIDTH}px)`;

/**
 * True when the viewport is wide enough that hover is the primary affordance
 * (desktop / laptop). False for tablets and phones where taps must open
 * click-based tooltips explicitly.
 */
export const useIsHoverViewport = (): boolean => {
  const [isHover, setIsHover] = useState(
    () =>
      typeof window !== "undefined" &&
      typeof window.matchMedia === "function" &&
      window.matchMedia(MEDIA_QUERY).matches
  );

  useEffect(() => {
    if (
      typeof window === "undefined" ||
      typeof window.matchMedia !== "function"
    ) {
      return;
    }
    const mq = window.matchMedia(MEDIA_QUERY);
    const handler = (e: MediaQueryListEvent) => setIsHover(e.matches);
    setIsHover(mq.matches);
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, []);

  return isHover;
};
